import { useEffect } from 'react'

import {
  hasConsentFor,
  HUBSPOT_IFRAME_ID,
  isHubspotChatLoaded,
  NODE_ENV
} from '../helpers'
import { useMount } from './use-mount'

const isEmbedded = () =>
  typeof window !== 'undefined' && window.self !== window.top

export const useTrackingScripts = (language) => {
  useMount(() => {
    if (NODE_ENV === 'development') return
    if (isEmbedded()) return

    const initializeGoogleTagManager = () => {
      const gtmScript = document.createElement('script')

      // hubspot chat comes from here
      gtmScript.id = 'gtm-script' // prevent duplicate insertion
      gtmScript.async = true
      gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-5XN2BQ7'

      gtmScript.onload = () => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        })
      }

      document.head.appendChild(gtmScript)
    }

    const initializeBingUET = () => {
      const bingScript = document.createElement('script')

      bingScript.id = 'bing-script' // prevent duplicate insertion
      bingScript.async = true
      bingScript.src = '//bat.bing.com/bat.js'

      bingScript.onload = () => {
        if (!window.UET) return

        window.uetq = window.uetq || []
        window.uetq.push('consent', 'default', {
          ad_storage: 'denied'
        })

        if (hasConsentFor('targeting')) {
          const o = { ti: '97118862', enableAutoSpaTracking: true }
          o.q = window.uetq
          window.uetq = new window.UET(o)
          window.uetq.push('pageLoad')
          window.uetq.push('consent', 'update', {
            ad_storage: 'granted'
          })
        }
      }

      document.head.appendChild(bingScript)
    }

    initializeGoogleTagManager()
    initializeBingUET()
  })

  // Initialize CookieScript with language - runs when language is available
  useEffect(() => {
    if (NODE_ENV === 'development') return
    if (!language) return
    if (isEmbedded()) return

    // Remove existing CookieScript if present (to reinitialize with correct language)
    const existingScript = document.getElementById('cdn-cookie-script')
    if (existingScript) return // Already initialized, don't duplicate

    const cdnCookieScript = document.createElement('script')

    cdnCookieScript.id = 'cdn-cookie-script'
    cdnCookieScript.src =
      '//cdn.cookie-script.com/s/5529df8370726e18cebb9caaa73ce2fd.js'
    cdnCookieScript.type = 'text/javascript'
    cdnCookieScript.setAttribute('data-cs-lang', language)

    document.head.appendChild(cdnCookieScript)
  }, [language])

  useMount(() => {
    const observer = new MutationObserver(() => {
      if (isHubspotChatLoaded()) {
        const hubspotChat = document.getElementById(HUBSPOT_IFRAME_ID)

        // hide the hubspot chat as soon as it appears in the dom
        // it gets displayed via the use-hubspot-chat.js hook for trial partners
        hubspotChat.style.display = 'none'
        hubspotChat.style.visibility = 'hidden'

        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  })
}
